import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { IconConfig } from '@rxap/utilities';
import { IconDirective } from '@rxap/material-directives/icon';
import { MatIconModule } from '@angular/material/icon';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'td[eurogard-icon-cell]',
  templateUrl: './icon-cell.component.html',
  styleUrls: [ './icon-cell.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ MatIconModule, IconDirective ],
})
export class IconCellComponent {

  @Input('eurogard-icon-cell')
  public icon!: IconConfig | null;

}
